module.exports = __webpack_public_path__ + "static/richard-branson-27829b39ebc11795265ed241e974e38d.jpg";